import ScalarMenuProduct_vue_vue_type_script_setup_true_lang_default from "./ScalarMenuProduct.vue.script.js";
//#region src/components/ScalarMenu/ScalarMenuProduct.vue
var ScalarMenuProduct_default = ScalarMenuProduct_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMenuProduct_default as default };

//# sourceMappingURL=ScalarMenuProduct.vue.js.map